/* eslint-disable */
// @ts-nocheck
import type { ApiRequestOptions, ApiErrorWithHeadersAndBody, ApiResult, IServiceInstanceOptions, ValidateResponse } from './types';
import type { SetAccountFraudInfoResponse, CreatePhoneNumberVerificationRequestResponse, ConfirmPhoneNumberVerificationRequestResponse, GetAccountPhoneNumberDetailsRequestResponse, CreateOtpTriggerRuleRequestResponse, GetCardVerificationsRequestResponse, BeginPaymentMethodVerificationResponse, GetLiveChatSettingsRequestResponse, SaveChatEventRequestResponse, GetSkipOtpCheckRequestResponse, GetSkipOtpCheckRequestV2Response, GetSignUpFraudInfoResponse, GetFraudInboxNotificationsResponse, UpdateFraudInboxNotificationResponse, GetKycInfoRequestResponse, GetKycInfoRequestV2Response, GetKycSettingsRequestResponse, GetConfirmedKycInfoRequestResponse, SetKycInfoRequestResponse, SetKycInfoRequestV2Response, UpdateKycInfoRequestResponse, UpdateKycInfoRequestV2Response, GetZendeskAuthTokenRequestResponse, GetDocUploadInfoRequestResponse, BeginDocUploadRequestResponse, GetDocUploadHistoryRequestResponse, CreateEmailOtpRequestResponse, ConfirmEmailOtpRequestResponse, GetKycVerificationInfoRequestResponse, CreateSoftKycVerificationRequestResponse } from './client/types.gen';
import { createExtensions } from './extensions';
import { getHMACHeaders, getEncryptedHeader, decodeResponse } from './core/patriannaRequest';
import { createClient } from './client/client';
import {
  setAccountFraudInfo,
  createPhoneNumberVerificationRequest,
  confirmPhoneNumberVerificationRequest,
  getAccountPhoneNumberDetailsRequest,
  createOtpTriggerRuleRequest,
  getCardVerificationsRequest,
  beginPaymentMethodVerification,
  getLiveChatSettingsRequest,
  saveChatEventRequest,
  getSkipOtpCheckRequest,
  getSkipOtpCheckRequestV2,
  getSignUpFraudInfo,
  getFraudInboxNotifications,
  updateFraudInboxNotification,
  getKycInfoRequest,
  getKycInfoRequestV2,
  getKycSettingsRequest,
  getConfirmedKycInfoRequest,
  setKycInfoRequest,
  setKycInfoRequestV2,
  updateKycInfoRequest,
  updateKycInfoRequestV2,
  getZendeskAuthTokenRequest,
  getDocUploadInfoRequest,
  beginDocUploadRequest,
  getDocUploadHistoryRequest,
  createEmailOtpRequest,
  confirmEmailOtpRequest,
  getKycVerificationInfoRequest,
  createSoftKycVerificationRequest,
} from './client/sdk.gen';

export enum Definition {
  X_MESSAGE_ID = 'xMessageId',
  X_TIMESTAMP = 'xTimestamp',
  BRAND_NAME = 'brandName',
  PLATFORM = 'platform',
  REQUEST_BODY = 'requestBody',
  X_CHK = 'xChk',
}

/** Maps our extension names to spec parameter location. Used under the hook for per-operation injection. */
const EXTENSION_SPEC: Record<string, { in: 'header' | 'query'; name: string }> = {
  xMessageId: { in: 'header', name: 'X-Message-Id' },
  xTimestamp: { in: 'header', name: 'X-Timestamp' },
  brandName: { in: 'query', name: 'brandName' },
  platform: { in: 'query', name: 'platform' },
  xChk: { in: 'query', name: 'xChk' },
};

const OPERATION_PARAMS: Record<string, { headers: string[]; query: string[] }> = {
  'setAccountFraudInfo': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'createPhoneNumberVerificationRequest': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'confirmPhoneNumberVerificationRequest': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getAccountPhoneNumberDetailsRequest': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'createOtpTriggerRuleRequest': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getCardVerificationsRequest': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'beginPaymentMethodVerification': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getLiveChatSettingsRequest': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'saveChatEventRequest': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'getSkipOtpCheckRequest': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'getSkipOtpCheckRequestV2': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'getSignUpFraudInfo': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'getFraudInboxNotifications': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'updateFraudInboxNotification': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'getKycInfoRequest': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'getKycInfoRequestV2': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'getKycSettingsRequest': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'getConfirmedKycInfoRequest': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'setKycInfoRequest': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'setKycInfoRequestV2': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'updateKycInfoRequest': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'updateKycInfoRequestV2': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'getZendeskAuthTokenRequest': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: [] },
  'getDocUploadInfoRequest': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'beginDocUploadRequest': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'getDocUploadHistoryRequest': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'createEmailOtpRequest': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'confirmEmailOtpRequest': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'getKycVerificationInfoRequest': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
  'createSoftKycVerificationRequest': { headers: ['X-Message-Id', 'X-Timestamp', 'X-Chk'], query: ['brandName', 'platform'] },
};

/** Creates a fetch that uses mTLS (key + cert). For server-side only. Uses Node's built-in fetch with undici Agent (bundled in Node 18+). Loaded dynamically so the client can run in browser when mTLS is not used. */
const createMtlsFetch = (key: string | Buffer, cert: string | Buffer) => {
  const { Agent } = require('undici') as typeof import('undici');
  const dispatcher = new Agent({
    connect: { key, cert, rejectUnauthorized: true },
  });
  return (request: Request): Promise<Response> =>
    fetch(request.url, {
      method: request.method,
      headers: request.headers,
      body: request.body,
      credentials: 'include',
      dispatcher,
    } as RequestInit);
};

export const createApiClient = (options: IServiceInstanceOptions) => {
  const useMtls = options.mtlsKey != null && options.mtlsCert != null;
  const client = createClient({
    baseUrl: options.url,
    credentials: 'include',
    ...(useMtls ? { fetch: createMtlsFetch(options.mtlsKey!, options.mtlsCert!) } : {}),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json, text/plain, */*',
      'X-Platform': typeof options.platform === 'string' ? options.platform : 'web',
      'X-Brand': options.brandName,
      ...(options.userAgent ? { 'user-agent': options.userAgent } : {}),
      ...(options.headers || {}),
    },
  });

  const urlSigningKey = options.urlSigningKey ?? options.urlSigningsKey;
  const encryptedMethods = options.encryptedMethods ?? [];

  client.interceptors.request.use(async (request: Request) => {
    const url = request.url;
    const hmac = getHMACHeaders(url, urlSigningKey, options.url);
    const encrypted = getEncryptedHeader(url, encryptedMethods);
    const headers = new Headers(request.headers);
    Object.entries(hmac).forEach(([k, v]) => headers.set(k, v));
    Object.entries(encrypted).forEach(([k, v]) => headers.set(k, v));
    return new Request(request, { headers, credentials: request.credentials });
  });

  client.interceptors.response.use(async (response: Response) => {
    if (!response.headers.get('X-Payload-Var')) return response;
    try {
      const data = await decodeResponse(response);
      const body = JSON.stringify(data);
      const headers = new Headers(response.headers);
      headers.set('Content-Type', 'application/json');
      headers.set('Content-Length', String(new TextEncoder().encode(body).length));
      return new Response(body, {
        status: response.status,
        statusText: response.statusText,
        headers,
      });
    } catch (e) {
      throw e;
    }
  });

  const extensions = createExtensions(options);

  const resolveExtensionValues = async (opId: string) => {
    const params = OPERATION_PARAMS[opId] ?? { headers: [], query: [] };
    const headers: Record<string, string> = {};
    const query: Record<string, string> = {};
    for (const [extName, spec] of Object.entries(EXTENSION_SPEC)) {
      const data = await Promise.resolve(extensions[extName]?.getData());
      const value = data != null ? String(data) : undefined;
      if (value === undefined) continue;
      if (spec.in === 'header' && params.headers.includes(spec.name)) {
        headers[spec.name] = value;
      }
      if (spec.in === 'query' && params.query.includes(spec.name)) {
        query[spec.name] = value;
      }
    }
    return { headers, query };
  };

  const buildRequestOpts = <TBody>(
    extHeaders: Record<string, string>,
    extQuery: Record<string, string>,
    requestBody: TBody,
    requestOptions?: ApiRequestOptions,
  ) => {
    const headers = { ...extHeaders, ...(requestOptions?.headers ?? {}) };
    const query = { ...extQuery, ...(requestOptions?.query ?? {}) };
    const { method: _method, responseStyle: _responseStyle, ...restOptions } = requestOptions ?? {};
    return { client, body: requestBody, responseStyle: 'fields' as const, ...restOptions, headers, query };
  };

  /** Returns data by default; returns { data, request, response } when options.responseStyle === 'full'. */
  const mapResponse = <T, O extends ApiRequestOptions | undefined>(
    result: { data: T; request: Request; response: Response },
    options?: O,
  ): ApiResult<T, O> =>
    (options?.responseStyle === 'full' ? result : result.data) as ApiResult<T, O>;

  /** When responseStyle !== 'full', throw on non-OK so callers get ApiErrorWithHeadersAndBody. When 'full', do not throw. */
  const maybeThrowOnError = (
    result: { data?: unknown; error?: unknown; request: Request; response: Response },
    responseStyle?: 'data' | 'full',
  ): void => {
    if (responseStyle === 'full' || result.response.ok) return;
    const raw = result.error ?? result.data;
    const body = typeof raw === 'object' && raw !== null
      ? { ...(raw as Record<string, unknown>) }
      : { errorText: raw != null ? String(raw) : undefined };
    const err = new Error(result.response.statusText || `HTTP ${result.response.status}`) as ApiErrorWithHeadersAndBody<unknown>;
    err.name = 'ApiError';
    err.request = result.request;
    err.response = result.response;
    err.headers = result.response.headers;
    err.body = body as ApiErrorWithHeadersAndBody['body'];
    err.statusText = result.response.statusText;
    throw err;
  };

  return {
    setAccountFraudInfo: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof setAccountFraudInfo>[0]['body'], requestOptions?: O): Promise<ApiResult<SetAccountFraudInfoResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('setAccountFraudInfo');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await setAccountFraudInfo(opts as Parameters<typeof setAccountFraudInfo>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<SetAccountFraudInfoResponse, O>;
    },
    createPhoneNumberVerificationRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof createPhoneNumberVerificationRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<CreatePhoneNumberVerificationRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('createPhoneNumberVerificationRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await createPhoneNumberVerificationRequest(opts as Parameters<typeof createPhoneNumberVerificationRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<CreatePhoneNumberVerificationRequestResponse, O>;
    },
    confirmPhoneNumberVerificationRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof confirmPhoneNumberVerificationRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<ConfirmPhoneNumberVerificationRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('confirmPhoneNumberVerificationRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await confirmPhoneNumberVerificationRequest(opts as Parameters<typeof confirmPhoneNumberVerificationRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<ConfirmPhoneNumberVerificationRequestResponse, O>;
    },
    getAccountPhoneNumberDetailsRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getAccountPhoneNumberDetailsRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<GetAccountPhoneNumberDetailsRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getAccountPhoneNumberDetailsRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getAccountPhoneNumberDetailsRequest(opts as Parameters<typeof getAccountPhoneNumberDetailsRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetAccountPhoneNumberDetailsRequestResponse, O>;
    },
    createOtpTriggerRuleRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof createOtpTriggerRuleRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<CreateOtpTriggerRuleRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('createOtpTriggerRuleRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await createOtpTriggerRuleRequest(opts as Parameters<typeof createOtpTriggerRuleRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<CreateOtpTriggerRuleRequestResponse, O>;
    },
    getCardVerificationsRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getCardVerificationsRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<GetCardVerificationsRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getCardVerificationsRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getCardVerificationsRequest(opts as Parameters<typeof getCardVerificationsRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetCardVerificationsRequestResponse, O>;
    },
    beginPaymentMethodVerification: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof beginPaymentMethodVerification>[0]['body'], requestOptions?: O): Promise<ApiResult<BeginPaymentMethodVerificationResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('beginPaymentMethodVerification');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await beginPaymentMethodVerification(opts as Parameters<typeof beginPaymentMethodVerification>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<BeginPaymentMethodVerificationResponse, O>;
    },
    getLiveChatSettingsRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getLiveChatSettingsRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<GetLiveChatSettingsRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getLiveChatSettingsRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getLiveChatSettingsRequest(opts as Parameters<typeof getLiveChatSettingsRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetLiveChatSettingsRequestResponse, O>;
    },
    saveChatEventRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof saveChatEventRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<SaveChatEventRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('saveChatEventRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await saveChatEventRequest(opts as Parameters<typeof saveChatEventRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<SaveChatEventRequestResponse, O>;
    },
    getSkipOtpCheckRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getSkipOtpCheckRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<GetSkipOtpCheckRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getSkipOtpCheckRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getSkipOtpCheckRequest(opts as Parameters<typeof getSkipOtpCheckRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetSkipOtpCheckRequestResponse, O>;
    },
    getSkipOtpCheckRequestV2: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getSkipOtpCheckRequestV2>[0]['body'], requestOptions?: O): Promise<ApiResult<GetSkipOtpCheckRequestV2Response, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getSkipOtpCheckRequestV2');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getSkipOtpCheckRequestV2(opts as Parameters<typeof getSkipOtpCheckRequestV2>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetSkipOtpCheckRequestV2Response, O>;
    },
    getSignUpFraudInfo: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getSignUpFraudInfo>[0]['body'], requestOptions?: O): Promise<ApiResult<GetSignUpFraudInfoResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getSignUpFraudInfo');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getSignUpFraudInfo(opts as Parameters<typeof getSignUpFraudInfo>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetSignUpFraudInfoResponse, O>;
    },
    getFraudInboxNotifications: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getFraudInboxNotifications>[0]['body'], requestOptions?: O): Promise<ApiResult<GetFraudInboxNotificationsResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getFraudInboxNotifications');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getFraudInboxNotifications(opts as Parameters<typeof getFraudInboxNotifications>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetFraudInboxNotificationsResponse, O>;
    },
    updateFraudInboxNotification: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof updateFraudInboxNotification>[0]['body'], requestOptions?: O): Promise<ApiResult<UpdateFraudInboxNotificationResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('updateFraudInboxNotification');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await updateFraudInboxNotification(opts as Parameters<typeof updateFraudInboxNotification>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<UpdateFraudInboxNotificationResponse, O>;
    },
    getKycInfoRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getKycInfoRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<GetKycInfoRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getKycInfoRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getKycInfoRequest(opts as Parameters<typeof getKycInfoRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetKycInfoRequestResponse, O>;
    },
    getKycInfoRequestV2: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getKycInfoRequestV2>[0]['body'], requestOptions?: O): Promise<ApiResult<GetKycInfoRequestV2Response, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getKycInfoRequestV2');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getKycInfoRequestV2(opts as Parameters<typeof getKycInfoRequestV2>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetKycInfoRequestV2Response, O>;
    },
    getKycSettingsRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getKycSettingsRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<GetKycSettingsRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getKycSettingsRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getKycSettingsRequest(opts as Parameters<typeof getKycSettingsRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetKycSettingsRequestResponse, O>;
    },
    getConfirmedKycInfoRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getConfirmedKycInfoRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<GetConfirmedKycInfoRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getConfirmedKycInfoRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getConfirmedKycInfoRequest(opts as Parameters<typeof getConfirmedKycInfoRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetConfirmedKycInfoRequestResponse, O>;
    },
    setKycInfoRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof setKycInfoRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<SetKycInfoRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('setKycInfoRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await setKycInfoRequest(opts as Parameters<typeof setKycInfoRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<SetKycInfoRequestResponse, O>;
    },
    setKycInfoRequestV2: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof setKycInfoRequestV2>[0]['body'], requestOptions?: O): Promise<ApiResult<SetKycInfoRequestV2Response, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('setKycInfoRequestV2');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await setKycInfoRequestV2(opts as Parameters<typeof setKycInfoRequestV2>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<SetKycInfoRequestV2Response, O>;
    },
    updateKycInfoRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof updateKycInfoRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<UpdateKycInfoRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('updateKycInfoRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await updateKycInfoRequest(opts as Parameters<typeof updateKycInfoRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<UpdateKycInfoRequestResponse, O>;
    },
    updateKycInfoRequestV2: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof updateKycInfoRequestV2>[0]['body'], requestOptions?: O): Promise<ApiResult<UpdateKycInfoRequestV2Response, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('updateKycInfoRequestV2');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await updateKycInfoRequestV2(opts as Parameters<typeof updateKycInfoRequestV2>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<UpdateKycInfoRequestV2Response, O>;
    },
    getZendeskAuthTokenRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getZendeskAuthTokenRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<GetZendeskAuthTokenRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getZendeskAuthTokenRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getZendeskAuthTokenRequest(opts as Parameters<typeof getZendeskAuthTokenRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetZendeskAuthTokenRequestResponse, O>;
    },
    getDocUploadInfoRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getDocUploadInfoRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<GetDocUploadInfoRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getDocUploadInfoRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getDocUploadInfoRequest(opts as Parameters<typeof getDocUploadInfoRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetDocUploadInfoRequestResponse, O>;
    },
    beginDocUploadRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof beginDocUploadRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<BeginDocUploadRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('beginDocUploadRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await beginDocUploadRequest(opts as Parameters<typeof beginDocUploadRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<BeginDocUploadRequestResponse, O>;
    },
    getDocUploadHistoryRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getDocUploadHistoryRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<GetDocUploadHistoryRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getDocUploadHistoryRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getDocUploadHistoryRequest(opts as Parameters<typeof getDocUploadHistoryRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetDocUploadHistoryRequestResponse, O>;
    },
    createEmailOtpRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof createEmailOtpRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<CreateEmailOtpRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('createEmailOtpRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await createEmailOtpRequest(opts as Parameters<typeof createEmailOtpRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<CreateEmailOtpRequestResponse, O>;
    },
    confirmEmailOtpRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof confirmEmailOtpRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<ConfirmEmailOtpRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('confirmEmailOtpRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await confirmEmailOtpRequest(opts as Parameters<typeof confirmEmailOtpRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<ConfirmEmailOtpRequestResponse, O>;
    },
    getKycVerificationInfoRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getKycVerificationInfoRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<GetKycVerificationInfoRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getKycVerificationInfoRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getKycVerificationInfoRequest(opts as Parameters<typeof getKycVerificationInfoRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetKycVerificationInfoRequestResponse, O>;
    },
    createSoftKycVerificationRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof createSoftKycVerificationRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<CreateSoftKycVerificationRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('createSoftKycVerificationRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await createSoftKycVerificationRequest(opts as Parameters<typeof createSoftKycVerificationRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<CreateSoftKycVerificationRequestResponse, O>;
    },
  };
};

export type * from './client';
